import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { getConsent, setConsent, trackPageview } from "@/lib/analytics";

export function AnalyticsTracker() {
  const location = useLocation();
  const [consentChoice, setConsentChoice] = useState(getConsent());

  useEffect(() => {
    trackPageview(location.pathname);
  }, [location.pathname, consentChoice]);

  if (consentChoice || location.pathname.startsWith("/admin")) return null;

  return (
    <div
      data-testid="cookie-consent-banner"
      className="fixed bottom-0 inset-x-0 z-[100] border-t border-slate-200 bg-white/95 backdrop-blur px-4 py-3 shadow-[0_-4px_20px_rgba(2,6,23,0.08)]"
    >
      <div className="max-w-5xl mx-auto flex items-center gap-3 flex-wrap">
        <p className="flex-1 min-w-[260px] text-xs text-slate-600 leading-relaxed">
          We use privacy-friendly, first-party analytics to understand site
          usage — pages visited, approximate location (country/city), device
          type and visit duration. No ads, no cross-site tracking, no data
          sold. You can decline and the site works exactly the same.
        </p>
        <div className="flex items-center gap-2">
          <button
            type="button"
            data-testid="consent-decline"
            onClick={() => {
              setConsent("denied");
              setConsentChoice("denied");
            }}
            className="text-xs font-mono uppercase tracking-wider px-3 py-1.5 rounded-sm border border-slate-300 text-slate-600 hover:bg-slate-50"
          >
            Decline
          </button>
          <button
            type="button"
            data-testid="consent-accept"
            onClick={() => {
              setConsent("granted");
              setConsentChoice("granted");
            }}
            className="text-xs font-mono uppercase tracking-wider px-3 py-1.5 rounded-sm bg-sky-600 hover:bg-sky-500 text-white"
          >
            Accept analytics
          </button>
        </div>
      </div>
    </div>
  );
}
